"use client"

import { baseUrl } from "@/util/api/baseUrl";
import { ConvertLink } from "@/util/tools";
import Aos from "aos";
import { ChevronDown } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";
import useSWR from 'swr';

interface BrandListType {
    timeStamp: string;
    statusCode: number;
    httpStatus: string;
    message: string;
    data: BrandListTypeDatum[];
}

interface BrandListTypeDatum {
    word: string;
    data: DatumDatum[];
}

interface DatumDatum {
    id: number;
    brand_title: string;
    brand_title_second: string;
    brand_url: string;
    brand_image: string;
    brand_image_alt: string;
}

const fetcher = (url: string) => fetch(url).then(res => res.json());

const LinkBrands = () => {
    const [open, setOpen] = useState(false);

    const { data: brandList, error, isValidating } = useSWR(
        open ? `${baseUrl}/brands-get` : null,
        fetcher,
        {
            revalidateOnFocus: false,
            dedupingInterval: 86400000, // کش یک روزه
        }
    );

    useEffect(() => {
        Aos.init({
            duration: 1000,
            once: false,
        });
    }, []);

    useEffect(() => {
        Aos.refresh();
    });

    return (
        <div
            className="relative"
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
        >
            <Link
                className={`text-sm flex items-center ${open ? "text-pink font-bold" : "text-text"
                    }`}
                href={"/brands"}
            >
                برندها
                <ChevronDown className="size-4 ml-1" />
            </Link>
            {open && (
                <div style={{ direction: "ltr" }} className="absolute top-full left-1/2 transform -translate-x-1/2">
                    <div className="flex flex-wrap w-[1000px] py-5 px-2 bg-main">
                        {isValidating ? (
                            <div className="flex justify-center items-center w-full">
                                {/* لودینگ */}
                                <span>در حال بارگذاری...</span>
                            </div>
                        ) : error ? (
                            <div className="flex justify-center items-center w-full">
                                <span>خطا در بارگذاری داده‌ها</span>
                            </div>
                        ) : (
                            brandList?.data?.map((item: BrandListTypeDatum, idx: number) => {
                                const time = idx * 50;
                                return (
                                    <div
                                        data-aos="fade-zoom-in"
                                        data-aos-delay={`${time}`}
                                        key={item.word}
                                        className="w-20 p-1  m-1 rounded-md"
                                    >
                                        <h2 className="font-bold text-lg mb-1 text-left">{item.word}</h2>
                                        {item.data?.map((brand: DatumDatum, index: number) => (
                                            <Link
                                                data-aos="fade-zoom-in"
                                                data-aos-delay={`${index + time}`}
                                                className="flex items-center justify-start text-left text-[12px] my-[1px] hover:text-pink transition-all duration-300 hover:font-bold opacity-80"
                                                key={brand?.id}
                                                href={`/brand/${ConvertLink(brand?.brand_url)}`}
                                            >
                                                {brand?.brand_title_second}
                                                {/* <Minus className="size-4 ml-1" />  */}
                                            </Link>
                                        ))}
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LinkBrands;
